export default "__VITE_ASSET__Cnwhc9$V__"